<template>
  <div>

    <head>
      <meta charset="utf-8" />
      <title>Login</title>
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <meta content="Keep your finances and membership up to date" name="description" />
      <meta content="" name="author" />
      <!-- App favicon -->
      <link rel="shortcut icon" href="assets/images/favicon.svg">

      <!-- owl.carousel css -->
      <link rel="stylesheet" href="assets/libs/owl.carousel/assets/owl.carousel.min.css">

      <link rel="stylesheet" href="assets/libs/owl.carousel/assets/owl.theme.default.min.css">

      <!-- Bootstrap Css -->
      <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
      <!-- Icons Css -->
      <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />
      <!-- App Css-->
      <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
      <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css" />

    </head>

    <body @contextmenu.prevent class="auth-body-bg">

    <div>
      <div class="container-fluid p-0">
        <div class="row g-0">

          <div class="col-xl-8 col-lg-8">
            <div class="pt-lg-5 p-4 bg-overlay" :style="backgroundStyle">

              <div class="w-100">
                <div class="bg-overlay"></div>
                <div class="d-flex h-100 flex-column">

                  <div class="p-4 mt-auto">
                    <div class="row justify-content-center">
                      <div class="col-lg-7">
                        <div class="text-center">
                          <img :src="county_logo()" alt="Logo" class="img mb-3" style="width: 170px;">

                          <h4 class="mb-0 text-white"><i class="bx bxs-quote-alt-left text-success h1 align-middle me-3"></i><span>Right there for you</span></h4>
                          <p class="font-size-16 text-white mb-0">Billing system.</p>
                          <strong>-</strong>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- end col -->

          <div class="col-xl-4 col-md-4">
            <div class="auth-full-page-content p-md-5 p-4">
              <div class="w-100">

                <div class="d-flex flex-column h-100">
                  <div class="mb-4 mb-md-5">
                    <a href="index.html" class="d-block auth-logo">
                      <img :src="county_logo()" alt="" height="18" class="auth-logo-dark">
                      <img :src="county_logo()" alt="" height="18" class="auth-logo-light">
                    </a>
                  </div>
                  <div class="my-auto">

                    <div>
                      <h5 class="text-success">Welcome Back!</h5>
                      <p class="text-muted">Sign in to continue using the <strong>Billing system.</strong> Use your employment number or ID number to access your account.
                      </p>
                    </div>

                    <div class="mt-4">
                      <form @submit.prevent="login">
                        <div class="mb-3">
                          <label for="username" class="form-label fw-semibold">Employment Number / ID Number <span class="text-danger">*</span></label>
                          <input v-model="contact.email" type="text" class="form-control" id="username" placeholder="Enter your employment number or ID number" required>
                          <small class="text-muted">You can use either your employment number or national ID number</small>
                        </div>

                        <div class="mb-3">
                          <div class="float-end">
                            <a href="#" @click.prevent="showForgotPasswordModal" class="text-muted">Forgot password?</a>
                          </div>
                          <label class="form-label">Password</label>
                          <div class="input-group auth-pass-inputgroup">
                            <input
                                v-model="password"
                                :type="showPassword ? 'text' : 'password'"
                                class="form-control"
                                placeholder="Enter password"
                                aria-label="Password"
                                aria-describedby="password-addon"
                                required>
                            <button
                                @click="togglePasswordVisibility"
                                class="btn btn-light"
                                type="button"
                                id="password-addon">
                              <i :class="showPassword ? 'mdi mdi-eye-off-outline' : 'mdi mdi-eye-outline'"></i>
                            </button>
                          </div>
                        </div>

                        <!-- Compact Location Indicator -->
                        <div class="mb-3">
                          <!-- Detecting -->
                          <div v-if="gettingLocation" class="location-mini location-mini-detecting">
                            <i class="mdi mdi-crosshairs-gps location-mini-icon spinning"></i>
                            <span class="location-mini-text">Detecting location...</span>
                          </div>

                          <!-- Success -->
                          <div v-else-if="locationCaptured" class="location-mini location-mini-success" @click="getCurrentLocation" title="Click to refresh">
                            <span class="live-dot"></span>
                            <i class="mdi mdi-map-marker-check location-mini-icon"></i>
                            <span class="location-mini-text">{{ displayLocationName }}</span>
                          </div>

                          <!-- Error -->
                          <div v-else-if="locationError" class="location-mini location-mini-error">
                            <i class="mdi mdi-map-marker-alert location-mini-icon"></i>
                            <span class="location-mini-text">Location needed</span>
                            <button type="button" @click="getCurrentLocation" class="location-mini-btn">
                              <i class="mdi mdi-refresh"></i>
                            </button>
                            <button type="button" @click="toggleMap" class="location-mini-btn">
                              <i class="mdi mdi-map-outline"></i>
                            </button>
                          </div>

                          <!-- Map Container -->
                          <div v-show="showMap" class="map-wrapper mt-2">
                            <div class="map-container">
                              <div v-if="mapInitializing" class="map-loading-overlay">
                                <i class="mdi mdi-loading mdi-spin"></i>
                              </div>
                              <div id="loginLeafletMap"></div>
                            </div>
                            <div class="map-footer">
                              <small><i class="mdi mdi-gesture-tap"></i> Tap to set location</small>
                              <button type="button" @click="showMap = false" class="map-close-btn">Close</button>
                            </div>
                          </div>
                        </div>

                        <div class="form-check">
                          <input
                              v-model="rememberMe"
                              @change="handleRememberMeChange"
                              class="form-check-input"
                              type="checkbox"
                              id="remember-check">
                          <label class="form-check-label" for="remember-check">
                            Remember me
                          </label>
                        </div>

                        <div v-if="alert.success" class="alert alert-success alert-dismissible fade show mt-3" role="alert">
                          <i class="mdi mdi-check-all me-2"></i>
                          {{message}}
                          <button type="button" class="btn-close" @click="alert.success = false"></button>
                        </div>

                        <div v-if="alert.info" class="alert alert-primary alert-dismissible fade show mt-3" role="alert">
                          <i class="mdi mdi-loading mdi-spin me-2"></i>
                          {{message}}
                        </div>

                        <div v-if="alert.failed" class="alert alert-danger alert-dismissible fade show mt-3" role="alert">
                          <i class="mdi mdi-alert me-2"></i>
                          {{message}}
                          <button type="button" class="btn-close" @click="alert.failed = false"></button>
                        </div>

                        <div class="mt-3 d-grid">
                          <button type="submit" class="btn btn-primary waves-effect waves-light" :disabled="!canLogin">
                            <span v-if="!alert.info">
                              <i class="mdi mdi-login me-1"></i> Log In
                            </span>
                            <span v-else><i class="mdi mdi-loading mdi-spin me-1"></i> Authorizing...</span>
                          </button>
                        </div>

                        <!-- Login Requirements Hint -->
                        <div v-if="!canLogin && !alert.info && !gettingLocation" class="text-center mt-2">
                          <small class="text-muted">
                            <span v-if="!contact.email || !password">Enter your credentials to continue</span>
                            <span v-else-if="!locationCaptured">Waiting for location...</span>
                          </small>
                        </div>
                      </form>
                    </div>
                  </div>

                  <div class="mt-4 mt-md-5 text-center">
                    <p class="mb-0 text-muted">© {{ new Date().getFullYear() }}. All rights reserved.</p>
                    <small class="text-muted">Version {{ versionCode }}</small>
                  </div>
                </div>


              </div>
            </div>
          </div>
          <!-- end col -->
        </div>
        <!-- end row -->
      </div>
      <!-- end container-fluid -->
    </div>

    <!-- Forgot Password Modal -->
    <div class="modal fade" id="forgotPasswordModal" tabindex="-1" aria-labelledby="forgotPasswordModalLabel" aria-hidden="true" ref="forgotPasswordModal">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header border-bottom-0">
            <h5 class="modal-title" id="forgotPasswordModalLabel">
              <i class="mdi mdi-lock-reset me-2 text-primary"></i>Reset Password
            </h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <p class="text-muted mb-4">
              Enter your <strong>employment number</strong> or <strong>ID number</strong> and we'll send password reset instructions to your registered mobile number and email.
            </p>

            <form @submit.prevent="forgotPassword">
              <div class="mb-3">
                <label for="resetIdNo" class="form-label fw-semibold">Employment Number / ID Number <span class="text-danger">*</span></label>
                <input
                    v-model="resetIdNo"
                    type="text"
                    class="form-control"
                    id="resetIdNo"
                    placeholder="Enter your employment number or ID number"
                    required>
                <small class="text-muted">You can use either your employment number or national ID number</small>
              </div>

              <div v-if="forgotAlert.success" class="alert alert-success alert-dismissible fade show" role="alert">
                <i class="mdi mdi-check-circle me-2"></i>
                {{ forgotMessage }}
                <button type="button" class="btn-close" @click="forgotAlert.success = false"></button>
              </div>

              <div v-if="forgotAlert.info" class="alert alert-primary" role="alert">
                <i class="mdi mdi-loading mdi-spin me-2"></i>
                {{ forgotMessage }}
              </div>

              <div v-if="forgotAlert.failed" class="alert alert-danger alert-dismissible fade show" role="alert">
                <i class="mdi mdi-alert me-2"></i>
                {{ forgotMessage }}
                <button type="button" class="btn-close" @click="forgotAlert.failed = false"></button>
              </div>

              <div class="d-grid gap-2">
                <button
                    type="submit"
                    class="btn btn-primary waves-effect waves-light"
                    :disabled="forgotAlert.info || !resetIdNo">
                  <span v-if="!forgotAlert.info">
                    <i class="mdi mdi-send me-1"></i>Send Reset Instructions
                  </span>
                  <span v-else>
                    <i class="mdi mdi-loading mdi-spin me-1"></i>Sending...
                  </span>
                </button>
                <button
                    type="button"
                    class="btn btn-secondary waves-effect"
                    data-bs-dismiss="modal"
                    :disabled="forgotAlert.info">
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!-- End Forgot Password Modal -->

    </body>

  </div>
</template>

<script>

/* eslint-disable */

import {authUrl, county_logo, login_bg, execute, getRight} from "@/api";
import router from "@/router";

export default {
  name: "LoginPage",
  data() {
    return {
      backgroundUrl: login_bg,
      versionCode: '1.0.0',

      // Device Information
      deviceId: '',
      deviceDetails: '',
      os: '',
      browser: '',
      screenResolution: '',
      cpuCores: '',
      memory: '',
      platform: '',
      userAgent: '',
      language: '',
      timezone: '',

      message: '',
      showPassword: false,
      rememberMe: false,

      // Location data
      locationData: {
        latitude: 0,
        longitude: 0,
        address: '',
        country: '',
        locality: '',
      },
      gettingLocation: false,
      locationError: null,
      showMap: false,
      mapInitializing: false,
      map: null,
      marker: null,
      fetchingAddress: false,

      // Forgot Password
      resetIdNo: '',
      forgotMessage: '',
      forgotAlert: {
        success: false,
        info: false,
        failed: false
      },

      selectedRoles: [
        {
          id: null,
          type: null,
          role: null
        }
      ],
      alert: {
        success: false,
        info: false,
        failed: false
      },
      contact: {
        email: ''
      },
      password: ''
    }
  },
  computed: {
    backgroundStyle() {
      return {
        backgroundImage: `url(${this.backgroundUrl})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
      };
    },
    locationCaptured() {
      return this.locationData.latitude !== 0 && this.locationData.longitude !== 0;
    },
    canLogin() {
      return this.contact.email && this.password && this.locationCaptured && !this.alert.info;
    },
    displayLocationName() {
      if (this.locationData.locality && this.locationData.country) {
        return `${this.locationData.locality}, ${this.locationData.country}`;
      } else if (this.locationData.locality) {
        return this.locationData.locality;
      } else if (this.locationData.country) {
        return this.locationData.country;
      } else if (this.locationData.address) {
        const parts = this.locationData.address.split(',');
        return parts.slice(0, 2).join(',').trim();
      }
      return 'Location detected';
    }
  },
  mounted() {
    this.generateDeviceId();
    this.getDeviceDetails();
    this.loadRememberedCredentials();
    this.getCurrentLocation();
  },
  beforeUnmount() {
    if (this.map) {
      this.map.remove();
      this.map = null;
    }
    this.marker = null;
  },
  methods: {
    county_logo() {
      return county_logo
    },
    login_bg() {
      return "url('https://api.elgeyomarakwet.go.ke/logo/bg-auth-overlay.png')";
    },

    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },

    // ==================== REMEMBER ME METHODS ====================

    handleRememberMeChange() {
      if (!this.rememberMe) {
        this.clearSavedCredentials();
      }
    },

    loadRememberedCredentials() {
      try {
        const savedRememberMe = localStorage.getItem("rememberMe");

        if (savedRememberMe === 'true') {
          this.rememberMe = true;

          const savedEmail = localStorage.getItem("rememberedEmail");
          if (savedEmail) {
            this.contact.email = this.decryptData(savedEmail);
          }

          const savedPassword = localStorage.getItem("rememberedPassword");
          if (savedPassword) {
            this.password = this.decryptData(savedPassword);
          }
        } else {
          this.rememberMe = false;
        }
      } catch (error) {
        console.error('Error loading saved credentials:', error);
        this.clearSavedCredentials();
      }
    },

    saveCredentials() {
      try {
        if (this.rememberMe) {
          localStorage.setItem("rememberMe", 'true');

          if (this.contact.email) {
            localStorage.setItem("rememberedEmail", this.encryptData(this.contact.email));
          }

          if (this.password) {
            localStorage.setItem("rememberedPassword", this.encryptData(this.password));
          }
        } else {
          this.clearSavedCredentials();
        }
      } catch (error) {
        console.error('Error saving credentials:', error);
      }
    },

    clearSavedCredentials() {
      localStorage.removeItem("rememberMe");
      localStorage.removeItem("rememberedEmail");
      localStorage.removeItem("rememberedPassword");
    },

    encryptData(data) {
      if (!data) return '';
      try {
        const base64 = btoa(unescape(encodeURIComponent(data)));
        let encrypted = '';
        for (let i = 0; i < base64.length; i++) {
          encrypted += String.fromCharCode(base64.charCodeAt(i) + 3);
        }
        return btoa(encrypted);
      } catch (error) {
        return btoa(data);
      }
    },

    decryptData(encryptedData) {
      if (!encryptedData) return '';
      try {
        const shifted = atob(encryptedData);
        let base64 = '';
        for (let i = 0; i < shifted.length; i++) {
          base64 += String.fromCharCode(shifted.charCodeAt(i) - 3);
        }
        return decodeURIComponent(escape(atob(base64)));
      } catch (error) {
        try {
          return atob(encryptedData);
        } catch (e) {
          return '';
        }
      }
    },

    // ==================== DEVICE METHODS ====================

    generateDeviceId() {
      let storedDeviceId = localStorage.getItem('deviceId');

      if (!storedDeviceId) {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        ctx.textBaseline = 'top';
        ctx.font = '14px Arial';
        ctx.fillText('DeviceFingerprint', 2, 2);
        const canvasFingerprint = canvas.toDataURL();

        const fingerprint = [
          navigator.userAgent,
          navigator.language,
          screen.colorDepth,
          screen.width + 'x' + screen.height,
          new Date().getTimezoneOffset(),
          navigator.hardwareConcurrency || 'unknown',
          navigator.deviceMemory || 'unknown',
          canvasFingerprint
        ].join('|');

        let hash = 0;
        for (let i = 0; i < fingerprint.length; i++) {
          const char = fingerprint.charCodeAt(i);
          hash = ((hash << 5) - hash) + char;
          hash = hash & hash;
        }

        storedDeviceId = 'WEB-' + Math.abs(hash).toString(16).toUpperCase() + '-' + Date.now().toString(36).toUpperCase();
        localStorage.setItem('deviceId', storedDeviceId);
      }

      this.deviceId = storedDeviceId;
    },

    getDeviceDetails() {
      const userAgent = navigator.userAgent;
      if (userAgent.indexOf('Win') !== -1) this.os = 'Windows';
      else if (userAgent.indexOf('Mac') !== -1) this.os = 'MacOS';
      else if (userAgent.indexOf('Linux') !== -1) this.os = 'Linux';
      else if (userAgent.indexOf('Android') !== -1) this.os = 'Android';
      else if (userAgent.indexOf('iOS') !== -1 || userAgent.indexOf('iPhone') !== -1 || userAgent.indexOf('iPad') !== -1) this.os = 'iOS';
      else this.os = 'Unknown';

      let browserName = 'Unknown';
      let browserVersion = '';

      if (userAgent.indexOf('Chrome') !== -1 && userAgent.indexOf('Edg') === -1) {
        browserName = 'Chrome';
        browserVersion = userAgent.match(/Chrome\/(\d+)/)?.[1] || '';
      } else if (userAgent.indexOf('Firefox') !== -1) {
        browserName = 'Firefox';
        browserVersion = userAgent.match(/Firefox\/(\d+)/)?.[1] || '';
      } else if (userAgent.indexOf('Safari') !== -1 && userAgent.indexOf('Chrome') === -1) {
        browserName = 'Safari';
        browserVersion = userAgent.match(/Version\/(\d+)/)?.[1] || '';
      } else if (userAgent.indexOf('Edg') !== -1) {
        browserName = 'Edge';
        browserVersion = userAgent.match(/Edg\/(\d+)/)?.[1] || '';
      } else if (userAgent.indexOf('MSIE') !== -1 || !!document.documentMode) {
        browserName = 'Internet Explorer';
      }
      this.browser = browserVersion ? `${browserName} ${browserVersion}` : browserName;

      this.screenResolution = `${window.screen.width}x${window.screen.height}`;
      this.cpuCores = navigator.hardwareConcurrency || 'Unknown';
      this.memory = navigator.deviceMemory ? `${navigator.deviceMemory}GB` : 'Unknown';
      this.platform = navigator.platform || 'Unknown';
      this.language = navigator.language || 'Unknown';
      this.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || 'Unknown';
      this.userAgent = userAgent;

      this.deviceDetails = [
        `os:${this.os}`,
        `browser:${this.browser}`,
        `resolution:${this.screenResolution}`,
        `cores:${this.cpuCores}`,
        `memory:${this.memory}`,
        `platform:${this.platform}`,
        `language:${this.language}`,
        `timezone:${this.timezone}`,
        `deviceId:${this.deviceId}`
      ].join(' | ');
    },

    // ==================== MODAL METHODS ====================

    showForgotPasswordModal() {
      this.resetIdNo = '';
      this.forgotMessage = '';
      this.forgotAlert.success = false;
      this.forgotAlert.info = false;
      this.forgotAlert.failed = false;

      const modal = new bootstrap.Modal(this.$refs.forgotPasswordModal);
      modal.show();
    },

    forgotPassword() {
      this.forgotAlert.success = false;
      this.forgotAlert.info = false;
      this.forgotAlert.failed = false;

      if (!this.resetIdNo || this.resetIdNo.trim() === '') {
        this.forgotAlert.failed = true;
        this.forgotMessage = 'Please enter your employment number or ID number';
        return;
      }

      this.forgotMessage = 'Sending reset instructions...';
      this.forgotAlert.info = true;

      const data = new FormData();
      data.append("function", "forgetPassword");
      data.append("idNo", this.resetIdNo.trim());

      execute(data, authUrl)
          .then((res) => {
            this.forgotAlert.info = false;

            if (res.data.success) {
              this.forgotAlert.success = true;
              this.forgotMessage = res.data.message || 'Password reset instructions have been sent to your registered mobile number and email.';

              setTimeout(() => {
                const modalElement = this.$refs.forgotPasswordModal;
                const modal = bootstrap.Modal.getInstance(modalElement);
                if (modal) {
                  modal.hide();
                }
              }, 3000);

            } else {
              this.forgotAlert.failed = true;
              this.forgotMessage = res.data.message || 'Failed to send reset instructions. Please try again.';
            }
          })
          .catch((e) => {
            this.forgotAlert.info = false;
            this.forgotAlert.failed = true;
            this.forgotMessage = 'An error occurred: ' + (e.message || 'Please try again later.');
          });
    },

    // ==================== LOCATION METHODS ====================

    getCurrentLocation() {
      if (!navigator.geolocation) {
        this.locationError = 'Geolocation not supported';
        this.showMap = true;
        this.$nextTick(() => {
          this.initLeafletMap();
        });
        return;
      }

      this.gettingLocation = true;
      this.locationError = null;

      navigator.geolocation.getCurrentPosition(
          (position) => {
            this.locationData.latitude = position.coords.latitude;
            this.locationData.longitude = position.coords.longitude;

            if (this.map && this.marker) {
              this.map.setView([this.locationData.latitude, this.locationData.longitude], 17);
              this.marker.setLatLng([this.locationData.latitude, this.locationData.longitude]);
            }

            this.gettingLocation = false;
            this.locationError = null;
            this.reverseGeocode(this.locationData.latitude, this.locationData.longitude);
          },
          (error) => {
            this.gettingLocation = false;

            switch (error.code) {
              case error.PERMISSION_DENIED:
                this.locationError = "Please enable location access";
                break;
              case error.POSITION_UNAVAILABLE:
                this.locationError = "Location unavailable";
                break;
              case error.TIMEOUT:
                this.locationError = "Request timed out";
                break;
              default:
                this.locationError = "Could not detect location";
            }
          },
          {enableHighAccuracy: true, timeout: 15000, maximumAge: 0}
      );
    },

    toggleMap() {
      this.showMap = !this.showMap;
      if (this.showMap) {
        this.$nextTick(() => {
          this.initLeafletMap();
        });
      }
    },

    initLeafletMap() {
      if (this.map) {
        setTimeout(() => {
          this.map.invalidateSize();
        }, 100);
        return;
      }

      this.mapInitializing = true;

      if (!document.getElementById('leaflet-css-login')) {
        const link = document.createElement('link');
        link.id = 'leaflet-css-login';
        link.rel = 'stylesheet';
        link.href = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
        link.integrity = 'sha256-p4NxAoJBhIIN+hmNHrzRCf9tD/miZyoHS5obTRR9BMY=';
        link.crossOrigin = '';
        document.head.appendChild(link);
      }

      const initMap = () => {
        const mapContainer = document.getElementById('loginLeafletMap');
        if (!mapContainer) {
          this.mapInitializing = false;
          return;
        }

        try {
          const initialLat = this.locationData.latitude !== 0 ? this.locationData.latitude : -1.286389;
          const initialLng = this.locationData.longitude !== 0 ? this.locationData.longitude : 36.817223;
          const initialZoom = this.locationCaptured ? 17 : 13;

          this.map = L.map('loginLeafletMap').setView([initialLat, initialLng], initialZoom);

          L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            maxZoom: 19,
            attribution: '© OpenStreetMap'
          }).addTo(this.map);

          this.marker = L.marker([initialLat, initialLng], {
            draggable: true
          }).addTo(this.map);

          this.marker.on('dragend', (e) => {
            const position = e.target.getLatLng();
            this.updateCoordinates(position.lat, position.lng);
          });

          this.map.on('click', (e) => {
            this.marker.setLatLng(e.latlng);
            this.updateCoordinates(e.latlng.lat, e.latlng.lng);
          });

          setTimeout(() => {
            if (this.map) {
              this.map.invalidateSize();
            }
          }, 300);

          this.mapInitializing = false;

        } catch (error) {
          this.mapInitializing = false;
        }
      };

      if (typeof L !== 'undefined') {
        setTimeout(initMap, 100);
      } else {
        const script = document.createElement('script');
        script.src = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
        script.integrity = 'sha256-20nQCchB9co0qIjJZRGuk2/Z9VM+kNiyxNV1lvTlZBo=';
        script.crossOrigin = '';
        script.onload = () => {
          setTimeout(initMap, 100);
        };
        document.head.appendChild(script);
      }
    },

    updateCoordinates(lat, lng) {
      this.locationData.latitude = lat;
      this.locationData.longitude = lng;
      this.locationError = null;
      this.reverseGeocode(lat, lng);
    },

    sanitizeString(str) {
      if (!str || typeof str !== 'string') return '';
      return str.replace(/['′'`"″"\\]/g, '').trim();
    },

    async reverseGeocode(lat, lng) {
      this.fetchingAddress = true;
      this.locationData.address = '';
      this.locationData.country = '';
      this.locationData.locality = '';

      try {
        const response = await fetch(
            `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}&addressdetails=1`,
            {
              headers: {
                'Accept-Language': 'en',
                'User-Agent': 'CountyBillingSystem/1.0'
              }
            }
        );

        if (response.ok) {
          const data = await response.json();
          if (data) {
            if (data.display_name) {
              this.locationData.address = this.sanitizeString(data.display_name);
            }

            if (data.address) {
              this.locationData.country = this.sanitizeString(data.address.country || '');
              this.locationData.locality = this.sanitizeString(
                  data.address.city ||
                  data.address.town ||
                  data.address.village ||
                  data.address.municipality ||
                  data.address.county ||
                  data.address.state ||
                  ''
              );
            }
          }
        }
      } catch (error) {
        this.locationData.address = '';
        this.locationData.country = '';
        this.locationData.locality = '';
      } finally {
        this.fetchingAddress = false;
      }
    },

    // ==================== LOGIN METHOD ====================

    login() {
      if (!this.locationCaptured) {
        this.alert.failed = true;
        this.message = "Please wait for location detection";
        return;
      }

      this.message = "Authorizing...";
      this.alert.failed = false;
      this.alert.info = true;

      const data = new FormData();

      data.append("function", "loginPortal");
      data.append("email", this.contact.email);
      data.append("password", this.password);
      data.append("latitude", this.locationData.latitude.toString());
      data.append("longitude", this.locationData.longitude.toString());
      data.append("country", this.locationData.country);
      data.append("address", this.locationData.address);
      data.append("locality", this.locationData.locality);
      data.append("versionCode", this.versionCode);
      data.append("deviceId", this.deviceId);
      data.append("source", "WEB");
      data.append("deviceDetails", this.deviceDetails);

      execute(data, authUrl)
          .then((res) => {
            this.alert.info = false;
            if (res.data.success) {

              this.saveCredentials();

              if (!res.data?.data?.user) {
                localStorage.setItem("tokenSession", res.data.data.tokenSession.token);
                sessionStorage.setItem("otpLength", res.data.data.otpLength);
                this.storeSessionData();
                router.push('otp');
              } else {
                sessionStorage.setItem("isLoggedIn", true);
                localStorage.setItem("tokenSession", res.data.data.tokenSession.token);
                sessionStorage.setItem("names", res.data.data.user.names);
                sessionStorage.setItem("otpLength", res.data.data.otpLength);
                sessionStorage.setItem("passwordChanged", res.data.data.user.passwordChanged);
                sessionStorage.setItem("idNo", res.data.data.user.idNo);
                sessionStorage.setItem("phoneNumber", res.data.data.user.phoneNumber);
                sessionStorage.setItem("subCountyName", res.data.data.user.subCountyName);
                sessionStorage.setItem("subCountyID", res.data.data.user.subCountyID);
                sessionStorage.setItem("wardID", res.data.data.user.wardID);
                sessionStorage.setItem("zone", res.data.data.user.zone);
                sessionStorage.setItem("category", res.data.data.user.category);
                sessionStorage.setItem("permission", res.data.data.user.permission);
                sessionStorage.setItem("sessionNames", res.data.data.user.names);
                sessionStorage.setItem("sessionIdNo", res.data.data.user.idNo);
                sessionStorage.setItem("sessionPhoneNumber", res.data.data.user.phoneNumber);
                sessionStorage.setItem("statusCode", res.data.data.user.statusCode);

                this.storeSessionData();

                this.message = res.data.message;
                this.alert.success = true;
                sessionStorage.setItem("selectedRoles", res.data.data.category.selectedRoles);
                sessionStorage.setItem("changePass", "change-password");

                if (getRight("DASHBOARD")) {
                  if (res.data.data.user.requireOTP === 'true') {
                    router.push('otp-verification');
                  } else {
                    router.push('dashboard');
                  }
                } else {
                  sessionStorage.setItem("isLoggedIn", false);
                  this.alert.success = false;
                  this.alert.failed = true;
                  this.message = "You don't have permission";
                }
              }

            } else {
              sessionStorage.setItem("isLoggedIn", false);
              this.alert.failed = true;
              this.message = res.data.message;
            }

          })
          .catch((e) => {
            this.alert.info = false;
            this.alert.failed = true;
            this.message = e.message;
          });
    },

    storeSessionData() {
      sessionStorage.setItem("loginLatitude", this.locationData.latitude.toString());
      sessionStorage.setItem("loginLongitude", this.locationData.longitude.toString());
      sessionStorage.setItem("loginAddress", this.locationData.address);
      sessionStorage.setItem("loginCountry", this.locationData.country);
      sessionStorage.setItem("loginLocality", this.locationData.locality);

      sessionStorage.setItem("versionCode", this.versionCode);
      sessionStorage.setItem("deviceId", this.deviceId);
      sessionStorage.setItem("deviceDetails", this.deviceDetails);
      sessionStorage.setItem("source", "WEB");
    }
  }
}

</script>

<style scoped>
.auth-full-bg {
  background-color: rgba(85, 110, 230, 0.25);
  display: flex;
  height: 100vh;
}

.auth-full-bg::before {
  content: "";
  position: absolute;
  width: 300px;
  height: 300px;
  border-radius: 50%;
}

.auth-pass-inputgroup .btn {
  border-left: 0;
}

.auth-pass-inputgroup input {
  border-right: 0;
}

/* ==================== COMPACT LOCATION INDICATOR ==================== */

.location-mini {
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 12px;
  gap: 6px;
  transition: all 0.2s ease;
}

.location-mini-icon {
  font-size: 14px;
}

.location-mini-text {
  font-weight: 500;
  max-width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Detecting State */
.location-mini-detecting {
  background: #f0f4ff;
  color: #5b73e8;
  border: 1px solid #d4dcf7;
}

.location-mini-detecting .spinning {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* Success State */
.location-mini-success {
  background: #f0fdf4;
  color: #16a34a;
  border: 1px solid #bbf7d0;
  cursor: pointer;
}

.location-mini-success:hover {
  background: #dcfce7;
}

.live-dot {
  width: 6px;
  height: 6px;
  background: #16a34a;
  border-radius: 50%;
  animation: pulse 1.5s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% { opacity: 1; transform: scale(1); }
  50% { opacity: 0.5; transform: scale(0.8); }
}

/* Error State */
.location-mini-error {
  background: #fef2f2;
  color: #dc2626;
  border: 1px solid #fecaca;
}

.location-mini-btn {
  background: none;
  border: none;
  color: inherit;
  padding: 2px 6px;
  cursor: pointer;
  border-radius: 4px;
  font-size: 14px;
  transition: background 0.2s;
}

.location-mini-btn:hover {
  background: rgba(0,0,0,0.1);
}

/* ==================== MAP STYLES ==================== */

.map-wrapper {
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #e5e7eb;
}

.map-container {
  height: 150px;
  background: #f3f4f6;
  position: relative;
}

#loginLeafletMap {
  width: 100%;
  height: 100%;
}

.map-loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255,255,255,0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  color: #5b73e8;
  font-size: 24px;
}

.map-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 10px;
  background: #f9fafb;
  border-top: 1px solid #e5e7eb;
}

.map-footer small {
  color: #6b7280;
  font-size: 11px;
}

.map-close-btn {
  background: none;
  border: none;
  color: #6b7280;
  font-size: 11px;
  cursor: pointer;
  padding: 2px 8px;
  border-radius: 4px;
}

.map-close-btn:hover {
  background: #e5e7eb;
  color: #374151;
}

/* ==================== RESPONSIVE ==================== */

.auth-full-page-content {
  max-height: 100vh;
  overflow-y: auto;
}

@media (max-width: 768px) {
  .auth-full-page-content {
    padding: 1rem !important;
  }
}
</style>